import React, { useEffect, useState } from 'react';
import GratuitousProgramsLayout from './GratuitousProgramsLayout';

export interface ProgramItem {
  id: string | number;
  title: string;
  description?: string;
}

export interface ProgramCategory {
  id: string | number;
  categoryTitle: string;
  programs: ProgramItem[];
}

const GratuitousProgramsPage: React.FC = () => {
  const [programsData, setProgramsData] = useState<ProgramCategory[]>([]);
  const [loading, setLoading] = useState<boolean>(true);
  const [error, setError] = useState<string | null>(null);

  useEffect(() => {
    const fetchPrograms = async () => {
      try {
        const baseUrl = process.env.REACT_APP_API_BASE_URL ?? 'http://localhost:8000';

        const response = await fetch(`${baseUrl}/api/v1/free-programs`);

        if (!response.ok) {
          throw new Error(`Ошибка HTTP: ${response.status}`);
        }

        const data = await response.json();
        setProgramsData(data);
      } catch (err: any) {
        console.error("Ошибка при загрузке программ:", err);
        setError('Не удалось загрузить список программ. Сервер недоступен.');
      } finally {
        setLoading(false);
      }
    };

    fetchPrograms();
  }, []);

  return (
    <GratuitousProgramsLayout>
      <div>
        <div className="mt-10 mb-20">
          <h1 className="text-3xl md:text-4xl font-bold text-gray-800">
            Программы, которые могут быть реализованы на безвозмездной основе
          </h1>
        </div>

        {loading && (
          <div className="flex justify-center items-center py-10">
            <p className="text-[#0B508B] text-xl font-semibold">Загрузка данных...</p>
          </div>
        )}

        {error && (
           <div className="bg-red-50 border-l-4 border-red-500 p-4 mb-8">
             <p className="text-red-700">{error}</p>
           </div>
        )}

        {!loading && !error && (
          <div className="space-y-12">
            {programsData.map((category) => (
              <div key={category.id}>
                <h2 className="text-2xl font-bold text-gray-800 mb-6 pl-3 border-l-4 border-[#0B508B]">
                  {category.categoryTitle}
                </h2>

                <ul className="space-y-4">
                  {category.programs.map((program) => (
                    <li
                      key={program.id}
                      className="bg-white border border-gray-200 rounded-lg p-5 hover:bg-gray-50 transition-colors duration-200"
                    >
                      <div className="flex flex-col md:flex-row md:items-baseline gap-2">
                        <span className="text-lg font-semibold text-[#0B508B]">
                          {program.title}
                        </span>
                      </div>
                    </li>
                  ))}
                </ul>
              </div>
            ))}
          </div>
        )}

        {!loading && !error && programsData.length === 0 && (
          <p className="text-gray-500 mt-10">Список программ временно недоступен.</p>
        )}

      </div>
    </GratuitousProgramsLayout>
  );
};

export default GratuitousProgramsPage;